import React from 'react';
import PropTypes from 'prop-types';
import Repeat from 'react-repeat-component';

const textRowsLength = [97, 92, 100, 95, 90];

const getRowStyle = (props, index) => {
  const { color, rows, textSize } = props;
  return {
    display: 'block',
    color: color,
    backgroundColor: color,
    height: `${textSize}px`,
    maxHeight: `${100 / (rows * 2 - 1)}%`,
    width: `${textRowsLength[index % 5]}%`
  };
};

const TextBlock = props => {
  const { className, rows } = props;
  return (
    <div className={className}>
      <Repeat times={rows}>
        {i => (
          <p key={i} style={getRowStyle(props, i)}>
            &nbsp;
          </p>
        )}
      </Repeat>
    </div>
  );
};

TextBlock.propTypes = {
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  rows: PropTypes.number.isRequired,
  textSize: PropTypes.number
};

TextBlock.defaultProps = {
  className: '',
  textSize: null
};

export default TextBlock;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/TextBlock/TextBlock.js